<div fxLayout="row wrap" fxLayoutAlign="start center">
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>売上年月</mat-label>
      <input matInput id="claimCalcYmt" value="{{urikakekinInfo.cdtmnySyosaiInfDto.claimCalcYmt ? (urikakekinInfo.cdtmnySyosaiInfDto.claimCalcYmt | slice:0:4) + '/' + 
            (urikakekinInfo.cdtmnySyosaiInfDto.claimCalcYmt | slice:4:6) : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>支払期限日</mat-label>
      <input matInput id="payDlineDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.payDlineDate ? (urikakekinInfo.cdtmnySyosaiInfDto.payDlineDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.payDlineDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.payDlineDate | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <div fxFlex="5" fxFlex.lt-md="100"></div>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>ガス料金</mat-label>
      <input matInput id="cdtmnyPretax" value="{{urikakekinInfo.cdtmnySyosaiInfDto.cdtmnyPretax | number:'1.0-0'}}"
        class="font-color-display-only" style="text-align: right;" disabled />
      <span matSuffix>円</span>
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>調定日</mat-label>
      <input matInput id="choteiDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.choteiDate ? (urikakekinInfo.cdtmnySyosaiInfDto.choteiDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.choteiDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.choteiDate | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>支払期限起算日</mat-label>
      <input matInput id="payDlineKisanDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.payDlineKisanDate ? (urikakekinInfo.cdtmnySyosaiInfDto.payDlineKisanDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.payDlineKisanDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.payDlineKisanDate | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <div fxFlex="5" fxFlex.lt-md="100"></div>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>内消費税（参考）</mat-label>
      <input matInput id="csptaxMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.csptaxMny | number:'1.0-0'}}"
        class="font-color-display-only" style="text-align: right;" disabled />
      <span matSuffix>円</span>
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>検針日</mat-label>
      <input matInput id="kensinYmd" value="{{urikakekinInfo.cdtmnySyosaiInfDto.kensinYmd ? (urikakekinInfo.cdtmnySyosaiInfDto.kensinYmd | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.kensinYmd | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.kensinYmd | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>延滞利息猶予期限日</mat-label>
      <input matInput id="dryrskClgrltDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.dryrskClgrltDate ? (urikakekinInfo.cdtmnySyosaiInfDto.dryrskClgrltDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.dryrskClgrltDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.dryrskClgrltDate | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <div fxFlex="5" fxFlex.lt-md="100"></div>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>延滞利息</mat-label>
      <input matInput id="delayRisoku" value="{{urikakekinInfo.cdtmnySyosaiInfDto.delayRisoku | number:'1.0-0'}}"
        class="font-color-display-only" style="text-align: right;" disabled />
      <span matSuffix>円</span>
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>検針区分</mat-label>
      <input matInput id="kensinDivAname" value="{{urikakekinInfo.cdtmnySyosaiInfDto.kensinDivAname}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>最終支払期限日</mat-label>
      <input matInput id="lastDlineDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.lastDlineDate ? (urikakekinInfo.cdtmnySyosaiInfDto.lastDlineDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.lastDlineDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.lastDlineDate | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>ご使用期間</mat-label>
      <!-- 期間の～表示有無をpipeに実装 -->
      <input matInput id="calcDate" value="{{(urikakekinInfo.cdtmnySyosaiInfDto.calcStartDate ? (urikakekinInfo.cdtmnySyosaiInfDto.calcStartDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.calcStartDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.calcStartDate | slice:6:8) 
      : '') | dateDuration : (urikakekinInfo.cdtmnySyosaiInfDto.calcEndDate ? (urikakekinInfo.cdtmnySyosaiInfDto.calcEndDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.calcEndDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.calcEndDate | slice:6:8) 
      : '')}}" class="font-color-display-only"
        disabled />
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>貸倒償却日</mat-label>
      <input matInput id="lossRegDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate ? (urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate | slice:0:4) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate | slice:4:6) + '/' + 
      (urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate | slice:6:8) 
      : ''}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>ご使用日数</mat-label>
      <input matInput id="empday" value="{{urikakekinInfo.cdtmnySyosaiInfDto.empday}}" class="font-color-display-only" style="text-align: right;"
        disabled />
      <span matSuffix>日</span>
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>延滞利息計算売掛金</mat-label>
      <input matInput id="dryrskCdtmny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.dryrskCdtmny}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <div fxFlex="5" fxFlex.lt-md="100"></div>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>合計金額</mat-label>
      <input matInput id="cdtmnyAllMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.cdtmnyAllMny | number:'1.0-0'}}"
        class="font-color-display-only" style="text-align: right;" disabled />
      <span matSuffix>円</span>
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>全体使用量</mat-label>
      <input matInput id="empamt" value="{{urikakekinInfo.cdtmnySyosaiInfDto.empamt}}" class="font-color-display-only" style="text-align: right;"
        disabled />
      <span matSuffix>m3</span>
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>適用料金表</mat-label>
      <input matInput id="fixedInfo" value="{{fixedInfo}}" class="font-color-display-only"
        disabled />
    </mat-form-field>
    <div fxFlex="5" fxFlex.lt-md="100"></div>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>入金額</mat-label>
      <input matInput id="rcvmnyFinMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.rcvmnyFinMny | number:'1.0-0'}}"
        class="font-color-display-only" style="text-align: right;" disabled />
      <span matSuffix>円</span>
    </mat-form-field>
  </div>
  <div fxFlex="100" fxFlex.lt-md="100" fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>料金訂正</mat-label>
      <input matInput id="chargeCorrctDivAname" value="{{urikakekinInfo.cdtmnySyosaiInfDto.chargeCorrctDivAname}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>まとめ請求</mat-label>
      <input matInput id="mtmclmAname" value="{{urikakekinInfo.cdtmnySyosaiInfDto.mtmclmDivAname}}"
        class="font-color-display-only" disabled />
    </mat-form-field>
    <div fxFlex="5" fxFlex.lt-md="100"></div>
    <mat-form-field appearance="fill" class="input-form" fxFlex="25" fxFlex.lt-md="100">
      <mat-label>未入金額</mat-label>
      <input matInput id="nrcptMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.nrcptMny | number:'1.0-0'}}"
        class="font-color-display-only" style="text-align: right;" disabled />
      <span matSuffix>円</span>
    </mat-form-field>
  </div>
</div>

<div fxLayout="row wrap" fxLayoutAlign="start center" style="margin-top: 20px;">
  <table mat-table id="cdtmnyDetailInfTbl" [dataSource]="urikakekinInfo.cdtmnySyosaiInfDto.cdtmnyDetailInfDto"
    fxFlex="60" fxFlex.lt-lg="100" style="width: 100%; border: solid 1px rgba(0, 0, 0, 0.12);">
    <ng-container matColumnDef="detailHyojiAname">
      <th mat-header-cell class="border-bottom-double" style="width: 20%; font-weight: bold;" *matHeaderCellDef>項目
      </th>
      <td mat-cell id="detailHyojiAname" class="border-bottom-double" style="width: 20%;  font-weight: bold;"
        *matCellDef="let e">
        {{e.detailHyojiAname }}</td>
    </ng-container>
    <ng-container matColumnDef="chargeCodeMny">
      <th mat-header-cell class="border-bottom-double" style="width: 20%; font-weight: bold;" *matHeaderCellDef>金額
      </th>
      <td mat-cell id="chargeCodeMny" class="border-bottom-double table-cell-type-num" style="width: 20%"
        *matCellDef="let e">
        <div *ngIf="prdClsfyDiv=='32'">
          {{e.chargeCodeMny | number:'1.4-4' }}円
        </div>
        <div *ngIf="prdClsfyDiv!='32'">
          {{e.chargeCodeMny | number:'1.2-2' }}円
        </div>        
      </td>
    </ng-container>

    <tr mat-header-row class="border-bottom-double" *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row class="border-bottom-double" *matRowDef="let row; columns: displayedColumns" class="mat-row">
    </tr>
  </table>
</div>